export const SESSION_KEY = 'pf-portal-session';
